import SButton from "components/Common/Button"
import { getOrderRepairByIdAPI, postOrderRepairByIdAPI } from "helpers/order"
import React, { useEffect, useState, useRef, forwardRef, Fragment } from "react"
import { useLocation, useHistory } from "react-router-dom"

import { Card, CardBody, Col, Container, Row } from "reactstrap"
import Repiar from "../Repair"
import { defaultValue } from "../Repair/default-value"
import Breadcrumb from "components/Common/Breadcrumb"
import Canvas from "./Canvas"
import SelectBox from "components/Common/SelectBox"
import { shipOrderApi } from "helpers/order_edit_resource"
import { toast } from "react-toastify"

const EditRepair = forwardRef((props, ref) => {
  const history = useHistory()

  const [payload, setPayload] = useState(defaultValue)
  const [activeTab, setActiveTab] = useState(0)
  const [canvas, setCanvas] = useState()
  const [trigger, setTrigger] = useState()
  const [canvasData, setCanvasData] = useState({ details: {} })
  const getCanvasRef = useRef()
  const {
    state: { id },
  } = useLocation()

  const loadOrderRepair = async () => {
    const res = await getOrderRepairByIdAPI(id)

    res.data.storeId = {
      label: res.data.storeName,
      value: res.data.storeId,
    }

    res.data.customerId = {
      label: res.data.customerName,
      value: res.data.customerId,
    }
    res.data.payments = res.data.payments ? res.data.payments : []

    setPayload(res.data)

    setCanvasData(res.data)
  }

  useEffect(() => {
    loadOrderRepair()
  }, [id])

  const [isSubmitting, setIsSubmitting] = useState(false)
  const onSubmitPress = () => {
    setIsSubmitting(true)
    setActiveTab(0)
    setTimeout(() => {
      setActiveTab(1)
    }, 500)
    setTimeout(() => {
      onSubmit()
    }, 1000)
  }

  const onSubmit = async () => {
    const getCanvas = await getCanvasRef?.current?.saveCanvas()

    try {
      let form = { ...payload }
      let handwritings
      if (getCanvas.details) {
        handwritings = getCanvas
      } else {
        handwritings = {
          details: [],
        }
      }
      form = {
        ...payload,
        storeId: payload?.storeId?.value ?? "",
        customerId: payload?.customerId?.value ?? "",
        handwriting: handwritings,
      }

      setTimeout(async () => {
        const res = await postOrderRepairByIdAPI(id, form)

        if (res.status === 200) {
          setIsSubmitting(false)
          toast.success(`保存しました。`)
          setTimeout(() => {
            history.push("/orders")
          }, 500)
        }
      }, 500)
    } catch (error) {
      console.log(error)
    }
  }

  const onShip = async () => {
    try {
      const data = await shipOrderApi(id)
      history.push("/orders")
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title={"受注一覧"} breadcrumbList={[]} />

        <Fragment>
          <Card>
            <CardBody>
              <Row>
                <Col style={{ placeSelf: "center" }} sm={1}>
                  商品選択
                </Col>
                <Col sm={3}>
                  <SelectBox
                    options={[]}
                    value={{ label: "お直し", value: "Repair" }}
                    isDisabled={true}
                  />
                </Col>
                <Col sm={3}>
                  <SelectBox
                    options={[]}
                    value={{ label: "お直し", value: "Repair" }}
                    isDisabled={true}
                  />
                </Col>
                {payload?.status === "検品済み" && (
                  <Col sm={4} className="d-flex justify-content-end">
                    {/* 出荷: shipping, only shows  when the status is "inspected" */}
                    <SButton className="button" onClick={onShip}>
                      出荷
                    </SButton>
                  </Col>
                )}

                <Col
                  sm={payload?.status === "検品済み" ? 1 : 5}
                  className="d-flex justify-content-end"
                >
                  <SButton
                    className="button"
                    loading={isSubmitting}
                    onClick={onSubmitPress}
                  >
                    保存
                  </SButton>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Repiar
            form={payload}
            ref={getCanvasRef}
            setForm={setPayload}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            edit
          />
        </Fragment>
      </Container>
    </div>
  )
})

export default EditRepair
